module.exports = __webpack_public_path__ + "static/media/there-you-go.e3a11e4e.mp3";